import { twMerge } from 'tailwind-merge';
import { InputProps } from '@theme/components/types';
import { ChangeEvent, forwardRef, useId, useState } from 'react';

export const FileInput = forwardRef<
  HTMLInputElement,
  InputProps & {
    defaultValue?: string;
    type?: string;
  }
>(({ className, id: customId, label, error, required, ...props }, ref) => {
  const [fileName, setFileName] = useState<string | null>(null);
  const defaultId = useId();
  const id = customId || defaultId;

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFileName(e.target.files[0].name);
    } else {
      setFileName(null);
    }
    if (props.onChange) {
      props.onChange(e);
    }
  };

  return (
    <div
      className={twMerge(
        'grid w-full max-w-sm items-center gap-1.5',
        className
      )}
    >
      {label && (
        <label htmlFor={id} className="text-xs text-gray">
          {label} {required && <span>*</span>}
        </label>
      )}
      <div className="flex items-center gap-2">
        <input
          {...props}
          id={id}
          type="file"
          ref={ref}
          onChange={handleFileChange}
          className="hidden" // Hide the default input
        />
        <label
          htmlFor={id}
          className="cursor-pointer bg-primary-black text-white hover:bg-primary-black/90 h-10 px-4 py-2 inline-flex items-center justify-center rounded-md text-sm font-medium"
        >
          Dosya Yükle
        </label>
        <span className="text-sm text-gray-500">
          {fileName || 'Dosya yüklenmedi'}
        </span>
      </div>
      {error && (
        <span className="mt-2 text-xs text-error">{error.message}</span>
      )}
    </div>
  );
});

FileInput.displayName = 'FileInput';
